export const TOP_MENU_HEIGHT = 46 as const;
export const EXPERIENCE_BUILDER_ID = 'experience-builder' as const;
export const FEATURED_SHADOW = '0 0 0 100vw rgba(78,77,76,0.83)' as const;
